<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
    [title]="editText"></love-it-modal-header>
  <ul
    #nav="ngbNav"
    class="nav nav-tabs card-header-tabs"
    ngbNav>
    <li
      [destroyOnHide]="false"
      ngbNavItem="stammdaten">
      <a
        [invalid]="submitted && formGroup.invalid"
        label="Stammdaten"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="officeId"
                  >Standort</label
                >
                <ng-select
                  [formControl]="formGroup.get('officeId') | formControl"
                  [items]="offices"
                  bindLabel="name"
                  bindValue="id"
                  [clearable]="false"
                  [searchable]="false"
                  id="officeId"
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('officeId')?.errors,
                  }"></ng-select>
                @if (submitted && formGroup.get("officeId")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("officeId")?.errors["required"]) {
                      <div>Standort ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-6">
                <label for="caregivers">Bezugsbetreuer:innen</label>
                <ng-select
                  [formControl]="formGroup.get('caregivers') | formControl"
                  [items]="employees"
                  bindLabel="name"
                  bindValue="id"
                  [clearable]="true"
                  id="caregivers"
                  [searchable]="true"
                  [multiple]="true"></ng-select>
              </div>
              <div class="col-sm-4">
                <label
                  class="required-label"
                  for="lastName"
                  >Nachname</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('lastName')?.errors,
                  }"
                  class="form-control"
                  formControlName="lastName"
                  id="lastName"
                  type="text" />
                @if (submitted && formGroup.get("lastName")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("lastName")?.errors["required"]) {
                      <div>Nachname ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-4">
                <label
                  class="required-label"
                  for="firstName"
                  >Vorname</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('firstName')?.errors,
                  }"
                  class="form-control"
                  formControlName="firstName"
                  id="firstName"
                  type="text" />
                @if (submitted && formGroup.get("firstName")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("firstName")?.errors["required"]) {
                      <div>Vorname ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-4">
                <label
                  for="birthday"
                  class="required-label"
                  >Geburtsdatum</label
                >
                <love-it-date-picker
                  id="birthday"
                  [clearable]="false"
                  [formControl]="getControl('birthday')"
                  [ngClass]="{
                    'is-invalid': submitted && getControl('birthday')?.errors,
                  }"></love-it-date-picker>
                @if (submitted && getControl("birthday")?.errors) {
                  <div class="invalid-feedback">
                    @if (getControl("birthday")?.errors["required"]) {
                      <div>Geburtsdatum ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-4">
                <label
                  for="entryDate"
                  class="required-label"
                  >Eintrittsdatum</label
                >
                <love-it-date-picker
                  id="entryDate"
                  [clearable]="false"
                  [formControl]="getControl('entryDate')"
                  [ngClass]="{
                    'is-invalid': submitted && getControl('entryDate')?.errors,
                  }"></love-it-date-picker>
                @if (submitted && getControl("entryDate")?.errors) {
                  <div class="invalid-feedback">
                    @if (getControl("entryDate")?.errors["required"]) {
                      <div>Eintrittsdatum ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-4">
                <label for="ssn">SVNr.</label>
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('ssn')?.errors,
                  }"
                  class="form-control"
                  formControlName="ssn"
                  id="ssn" />
              </div>
              <div class="col-sm-4"></div>
              <div class="col-sm-6">
                <label for="phone">Handy</label>
                <love-it-tel-input
                  id="phone"
                  [formControl]="getControl('phone')"
                  [ngClass]="{
                    'is-invalid': submitted && getControl('phone')?.errors,
                  }"></love-it-tel-input>
              </div>
              <div class="col-sm-6">
                <label for="email">E-Mail</label>
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('email')?.errors,
                  }"
                  class="form-control"
                  formControlName="email"
                  id="email"
                  type="email" />
                @if (submitted && getControl("email")?.errors) {
                  <div class="invalid-feedback">
                    @if (getControl("phone")?.errors["email"]) {
                      <div>Geben Sie eine gültige Email-Adresse ein.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-4">
                <label for="gz">GZ</label>
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('gz')?.errors,
                  }"
                  class="form-control"
                  formControlName="gz"
                  id="gz" />
              </div>
              @if (getCurrentOfficeType() !== OfficeType.KJH){
                <div class="col-sm-4">
                  <label for="ifa">IFA</label>
                  <input
                    [ngClass]="{
                    'is-invalid': submitted && formGroup.get('ifa')?.errors,
                  }"
                    class="form-control"
                    formControlName="ifa"
                    id="ifa" />
                </div>
                <div class="col-sm-4">
                  <label
                    class="required-label"
                    for="status"
                  >Status</label
                  >
                  <ng-select
                    [formControl]="formGroup.get('status') | formControl"
                    [items]="clientStati"
                    bindLabel="display"
                    bindValue="value"
                    [clearable]="false"
                    [searchable]="false"
                    id="status"
                    [ngClass]="{
                        'is-invalid': submitted && formGroup.get('status')?.errors,
                      }"></ng-select>
                  @if (submitted && formGroup.get("status")?.errors) {
                    <div class="invalid-feedback">
                      @if (formGroup.get("status")?.errors["required"]) {
                        <div>Status ist ein Pflichtfeld.</div>
                      }
                    </div>
                  }
                </div>
              }
              <div class="col-sm-12">
                <label for="comment">Anmerkungen</label>
                <textarea
                  id="comment"
                  class="form-control"
                  formControlName="comment"
                  rows="5"></textarea>
              </div>
              @if (getCurrentOfficeType() !== OfficeType.KJH){
                <div class="col-sm-4">
                  <label for="housingId">Wohnung</label>
                  <ng-select
                    [formControl]="formGroup.get('housingId') | formControl"
                    [items]="housings"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="true"
                    [searchable]="true"
                    id="housingId"></ng-select>
                </div>
                <div class="col-sm-4">
                  <label for="roomNr">Zimmernr.</label>
                  <input
                    [ngClass]="{
                      'is-invalid': submitted && formGroup.get('roomNr')?.errors,
                    }"
                    class="form-control"
                    formControlName="roomNr"
                    id="roomNr" />
                </div>
              }
            </div>
          </div>
          @if (entity) {
            <div class="card-footer">
              <app-reports-list
                [id]="entity.id"
                [type]="ReportEntryCategory.Standard" />
            </div>
          }
        </div>
      </ng-template>
    </li>
    @if (getCurrentOfficeType() === OfficeType.KJH){
      <li
        [destroyOnHide]="false"
        ngbNavItem="psychosozielaEntwicklung">
        <a
          label="Psychosoziale Entw."
          love-it-tab
          ngbNavLink></a>
        <ng-template ngbNavContent>
          <div class="card">
            @if (entity) {
              <div class="card-footer">
                <app-reports-list
                  [id]="entity.id"
                  [type]="ReportEntryCategory.PsychosozialeEntwicklung" />
              </div>
            }
          </div>
        </ng-template>
      </li>
      <li
        [destroyOnHide]="false"
        ngbNavItem="sozioaekonomischeEntwicklung">
        <a
          label="Sozioökonomische Entw."
          love-it-tab
          ngbNavLink></a>
        <ng-template ngbNavContent>
          <div class="card">
            @if (entity) {
              <div class="card-footer">
                <app-reports-list
                  [id]="entity.id"
                  [type]="ReportEntryCategory.SoziooekonomischeEntwicklung" />
              </div>
            }
          </div>
        </ng-template>
      </li>
    }
    <li
      [destroyOnHide]="false"
      ngbNavItem="education">
      <a
        label="Bildung"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <label for="education">Bildung</label>
                <textarea
                  id="education"
                  class="form-control"
                  formControlName="education"></textarea>
              </div>
            </div>
          </div>
          @if (entity) {
            <div class="card-footer">
              <app-reports-list
                [id]="entity.id"
                [type]="ReportEntryCategory.Bildung" />
            </div>
          }
        </div>
      </ng-template>
    </li>
    <li
      [destroyOnHide]="false"
      ngbNavItem="medicine">
      <a
        label="Gesundheit"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <label for="drugs">Medikamente</label>
                <textarea
                  id="drugs"
                  class="form-control"
                  formControlName="drugs"></textarea>
              </div>
              <div class="col-sm-12">
                <label for="allergies">Allergien</label>
                <textarea
                  id="allergies"
                  class="form-control"
                  formControlName="allergies"></textarea>
              </div>
              <div class="col-sm-12">
                <label for="vaccines">Impfungen</label>
                <textarea
                  id="vaccines"
                  class="form-control"
                  formControlName="vaccines"></textarea>
              </div>
            </div>
          </div>
          @if (entity) {
            <div class="card-footer">
              <app-reports-list
                [id]="entity.id"
                [type]="ReportEntryCategory.Gesundheit" />
            </div>
          }
        </div>
      </ng-template>
    </li>
    @if (getCurrentOfficeType() === OfficeType.KJH){
      <li
        [destroyOnHide]="false"
        ngbNavItem="umfeld">
        <a
          label="Umfeld & Kontakte"
          love-it-tab
          ngbNavLink></a>
        <ng-template ngbNavContent>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <label for="contacts">Wichtige Kontakte</label>
                  <textarea
                    id="contacts"
                    class="form-control"
                    formControlName="contacts"></textarea>
                </div>
              </div>
            </div>
            @if (entity) {
              <div class="card-footer">
                <app-reports-list
                  [id]="entity.id"
                  [type]="ReportEntryCategory.Umfeld" />
              </div>
            }
          </div>
        </ng-template>
      </li>
    } @else {
      <li
        [destroyOnHide]="false"
        ngbNavItem="asylum">
        <a
          label="Asyl und Integration"
          love-it-tab
          ngbNavLink></a>
        <ng-template ngbNavContent>
          <div class="card">
            @if (entity) {
              <div class="card-body">
                <app-reports-list
                  [id]="entity.id"
                  [type]="ReportEntryCategory.AsylUndIntegration" />
              </div>
            }
          </div>
        </ng-template>
      </li>
      <li
        [destroyOnHide]="false"
        ngbNavItem="sparetime">
        <a
          label="Freizeit"
          love-it-tab
          ngbNavLink></a>
        <ng-template ngbNavContent>
          <div class="card">
            @if (entity) {
              <div class="card-body">
                <app-reports-list
                  [id]="entity.id"
                  [type]="ReportEntryCategory.Freizeit" />
              </div>
            }
          </div>
        </ng-template>
      </li>
    }
  </ul>
  <div class="modal-body">
    <div
      [ngbNavOutlet]="nav"
      class="mt-2"></div>
  </div>
  <div class="modal-footer">
    @if (entity?.id) {
      <button
        rippleEffect
        type="button"
        class="btn-mobile-group btn-outline-primary"
        (click)="openTimeframeModal(entity)">
        Klientenbericht herunterladen
      </button>
    }
    <love-it-modal-buttons
      (onSubmit)="onSubmit($event)"
      [dirty]="formGroup.dirty"
      [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.Client"></love-it-modal-buttons>
  </div>
</form>
